export default "__VITE_ASSET__cdbca909__"